import React from 'react';
import { observer } from 'mobx-react';
import { SpaceLink, SpaceLinkProps } from '../SpaceLink';

interface SharedByProps extends SpaceLinkProps {}

export const SharedBy = observer(function SharedBy({
  label = 'shared by',
  size = 'small',
  underlined,
  variant,
  space,
}: SharedByProps) {
  return (
    <SpaceLink
      underlined={underlined}
      variant={variant}
      space={space}
      label={label}
      size={size}
    />
  );
});
